import React from 'react';

export default function Timeline({ events, notice }) {
    return (
        <>
            {notice && (
                <>
                    <br />
                    <div className="notification-container info pb-2">
                        <div className="message-and-details">
                            <p className="message">{notice}</p>
                        </div>
                    </div>
                    <br />
                </>
            )}

            <div className="order-timeline">
                {events.map((event, index) => (
                    <div
                        key={index}
                        className={['order-timeline__item', event.state && `order-timeline__item--${event.state}`].filter(Boolean).join(' ')}
                    >
                        <span className="timeline-event-icon" />
                        <span className="timeline-event-details" data-pull="no">
                            <h3>{event.title}</h3>
                            <span>{event.date}</span>
                        </span>
                    </div>
                ))}
            </div>
        </>
    );
}
